(function () {
  var PIN_RE = /^[1-9][0-9]{5}$/;
  var DEFAULT_API_URL = 'https://fclo-delivery-estimate.ritu-2db.workers.dev';
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  function setMessage(root, text, state) {
    var el = root.querySelector('[data-fclo-delivery-message]');
    if (!el) return;

    if (!text) {
      el.hidden = true;
      el.textContent = '';
      el.classList.remove('is-success', 'is-error', 'is-info');
      return;
    }

    el.hidden = false;
    el.textContent = text;
    el.classList.remove('is-success', 'is-error', 'is-info');
    if (state) el.classList.add(state);
  }

  function setLoading(root, loading) {
    var btn = root.querySelector('[data-fclo-delivery-submit]');
    var label = root.querySelector('[data-fclo-delivery-btn-label]');
    var loadingEl = root.querySelector('[data-fclo-delivery-btn-loading]');
    var input = root.querySelector('[data-fclo-delivery-input]');

    if (btn) btn.disabled = loading;
    if (input) input.disabled = loading;
    if (label) label.hidden = loading;
    if (loadingEl) {
      loadingEl.hidden = !loading;
      loadingEl.setAttribute('aria-hidden', loading ? 'false' : 'true');
    }
  }

  function buildApiUrl(apiBase, pin) {
    var base = String(apiBase || DEFAULT_API_URL).trim();
    if (!base) base = DEFAULT_API_URL;
    base = base.replace(/\/$/, '');
    if (base.indexOf('pincode=') !== -1) {
      return base.replace(/pincode=[^&]*/, 'pincode=' + encodeURIComponent(pin));
    }
    var join = base.indexOf('?') === -1 ? '?' : '&';
    return base + join + 'pincode=' + encodeURIComponent(pin);
  }

  function formatEstimatedDate(tat) {
      var days = parseInt(tat, 10);

      if (isNaN(days) || days < 0) days = 0;

      var startDate = new Date();
      startDate.setHours(0, 0, 0, 0);
      startDate.setDate(startDate.getDate() + days);

      var endDate = new Date(startDate);
      endDate.setDate(endDate.getDate() + 1);

      function formatDate(date) {
          return WEEKDAYS[date.getDay()] + ', ' +
              date.getDate() + ' ' +
              MONTHS[date.getMonth()] + ' ' +
              date.getFullYear();
      }

      return formatDate(startDate) + ' - ' + formatDate(endDate);
  }

  function buildSuccessMessage(template, estimatedDate) {
    var message = template || 'Approx. estimated delivery by {date}.';
    if (message.indexOf('{date}') === -1) {
      return message.replace(/\.?\s*$/, '') + ' Approx. estimated delivery by ' + estimatedDate + '.';
    }
    return message.replace(/\{date\}/g, estimatedDate);
  }

  function checkPincode(root, pin) {
    var apiUrl = root.getAttribute('data-api-url') || DEFAULT_API_URL;
    var successMessage = root.getAttribute('data-success-message') || 'Approx. estimated delivery by {date}.';
    var errorMessage = root.getAttribute('data-error-message') || 'Sorry, delivery is not available for this pincode.';
    var requestUrl = buildApiUrl(apiUrl, pin);

    setLoading(root, true);
    setMessage(root, '', null);

    fetch(requestUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        var payload = result.data || {};
        if (payload.success === true && payload.data && payload.data.tat != null) {
          var estimatedDate = formatEstimatedDate(payload.data.tat);
          setMessage(root, buildSuccessMessage(successMessage, estimatedDate), 'is-success');
          return;
        }

        setMessage(root, payload.msg || errorMessage, 'is-error');
      })
      .catch(function () {
        setMessage(
          root,
          'Unable to check delivery right now. Please try again in a moment.',
          'is-error'
        );
      })
      .finally(function () {
        setLoading(root, false);
      });
  }

  function bind(root) {
    if (!root || root.dataset.fcloDeliveryBound === 'true') return;
    root.dataset.fcloDeliveryBound = 'true';

    var form = root.querySelector('[data-fclo-delivery-form]');
    var input = root.querySelector('[data-fclo-delivery-input]');
    if (!form || !input) return;

    input.addEventListener('input', function () {
      input.value = input.value.replace(/\D/g, '').slice(0, 6);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var pin = (input.value || '').trim();
      var invalidMessage =
        root.getAttribute('data-invalid-message') || 'Please enter a valid 6-digit pincode.';

      if (!PIN_RE.test(pin)) {
        setMessage(root, invalidMessage, 'is-error');
        input.focus();
        return;
      }

      checkPincode(root, pin);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-fclo-delivery-check]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
